import { createGlobalStyle } from "styled-components";
import { theme } from "@smooth-ui/core-sc";
import { default as reakitTheme } from "reakit-theme-default";
import { css } from "reakit";
import { palette as p } from "styled-tools";
import colors from "./colors";
import buttonVariants from "./buttons";
import cardVariants from "./cards";

export const GlobalStyle = createGlobalStyle`
	@font-face {
		font-family: 'Lato', sans-serif;
		src: url("https://fonts.googleapis.com/css?family=Lato:300,400,600,700|Open+Sans:400,600,700,800,900");
	}
	html {
		min-height: 100vh;
	}
	body {
		font-family: 'Lato', sans-serif !important;
		padding: 0;
		margin: 0;
		color: #0a0a0a;
	}
	a {
		text-decoration: none;
	}
`;

export { default as colors } from "./colors";

let myReakitTheme = reakitTheme;

delete myReakitTheme.Heading;
delete myReakitTheme.Paragraph;

export default {
  ...theme,
  ...myReakitTheme,
  palette: {
    ...reakitTheme.palette,
    /* https://coolors.co/26547c-a3d5ff-476c9b-8b95c9-637081*/
    primary: ["#D1d1d1", "#969a9b", "#476C9B", "#8B95C9", "#637081"],
    secondary: ["#02394a", "#043e77", "#ff7fc1", "#21cad3", "#b363f9"],
    whites: ["white", "#e8e8e8", "#d1d1d1", "#bababa", "#bababa"],
    greys: ["#121212", "#495867", "#326273", "#c5c5c5", "#56666b"],
    blacks: ["#263039", "#000000"],
    greysText: [p("white"), p("white"), p("white"), p("black"), p("white")],
    transparent: ["transparent"],
  },
  Button: css`
    border-radius: 50px;
    //box-shadow: 0 0 6px rgba(0, 0, 0, .16);
    //width: 187px;
    height: "47px";
    width: "47px";
    //height: 47px;
    overflow: hidden;
    &:focus {
      outline: none;
    }
  `,
  breakpoints: ["40em", "800px", "1200px", "1900px"],
  fontSizes: [12, 14, 17, 21, 24, 32, 48, 64],
  colors,
  fonts: {
    sans: "Montserrat, sans-serif",
    mono: "Montserrat, sans-serif",
    // sf: '-apple-system,'
  },
  shadows: {
    small: "0 0 4px rgba(0, 0, 0, .125)",
    large: "0 0 24px rgba(0, 0, 0, .125)",
    inset: "0 0 6px rgba(0, 0, 0, .16)",
    main: "0 0 6px rgba(0, 0, 0, .16)",
    right: "0 3px 6px rgba(0, 0, 0, .16);",

    none: "none",
  },
  buttons: {
    ...buttonVariants,
  },
  cards: {
    ...cardVariants,
  },
  Table: css`
			border: none;
		  table-layout: fixed;
		  border-collapse: collapse;
		  background-color: white;
		  thead {
		    line-height: 200%;
		
		  }
		  tbody,
		  td,
		  th,
		  tfoot,
		  thead,
		  tr {
		    border: inherit;
		  }
		  caption {
		    text-transform: uppercase;
		    font-size: 0.9em;
		    color: ${p("grayscale", 3)};
		  }
		  td,
		  th {
		    //padding: 0 2px;
		    //vertical-align: center;
		    //font-size: 14px;
		    @media(max-width: 1240px){
		    //padding: 0 2px;
		
		    }
		  }
		  td {
		  font-weight: 600;
		  //font-size: 11px;
		    @media(max-width: 1200px){
		      font-size: 11px;
		    }
		    button {
						font-size: 11px !important;
					}
		  }
		  th {
		    font-weight: 700;
		    // background-color: ${p("shadow", -1)};
		    //@media(max-width: 1240px){
		    //    font-size: 14px;
			//		
		    //}
		    button {
						font-size: 14px !important;
					}
		  }
	`,
  Tabs: css`
    ${reakitTheme.Tabs};
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.16);
    //margin-top: -30px;
    width: 100%;
    padding: 4px;
    @media (max-width: 700px) {
      box-shadow: none;
      padding: initial;
    }
  `,
  TabsTab: css`
    ${reakitTheme.TabsTab};
    span {
    }
    color: #969a9b;
    font-weight: 600;
    padding-top: 3px;
    margin-right: 20px;
    div div span {
      position: relative;
      padding-top: 7px;
      display: block;
      border-bottom: 2px solid white;
      @media (max-width: 700px) {
        bottom: -10px;
        padding-top: 0px;
      }
    }
    &.active {
      //padding-top: 2px;
      font-weight: 600;
      color: #263039;
    }
    &.active div div span {
      position: relative;
      bottom: -10px;
      display: block;
      border-bottom: 2px solid #2b80b9;
    }
    @media (max-width: 700px) {
      margin-right: initial;
      padding-top: initial;
    }
  `,
  Input: css`
    ${reakitTheme.Input};
    &:focus {
      outline: none;
    }
  `,
};
